import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { IJBPMasterDealerDataView } from 'clickNgo/models/crud/views'
import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

export const getJbpMasterDealerDataCrud = (key?: string) =>
  CrudStore.get(CrudStoreItem.JBPMasterDealerData, key) as Crud<IJBPMasterDealerDataView>
